/** Os endereços de antes das áreas (24/10/2026), quando tudo morava em `/backoffice`.
 *
 *  Favorito, link copiado num grupo, rota gravada pelo servidor numa pendência e a
 *  resposta antiga do assistente continuam apontando para `/backoffice/...`. Esta
 *  tabela diz para onde cada um foi, e é a mesma que trocou os endereços no código:
 *  um mapa só, para o redirecionamento e a troca nunca discordarem.
 *
 *  Sem import de React de propósito: o script que trocou os literais roda este
 *  arquivo direto no Node. */

export const PREFIXO_LEGADO = '/backoffice'

/** Antigo → novo, por prefixo de segmento inteiro. O primeiro que casa vence, então
 *  o mais específico vem antes. */
const REGRAS: ReadonlyArray<readonly [string, string]> = [
  // Usuários e Cargos saíram de dentro do hub e viraram itens do Administrativo.
  ['/backoffice/cadastros/usuarios', '/administrativo/usuarios'],
  ['/backoffice/cadastros/cargos', '/administrativo/cargos'],
  // Os dois endereços antigos de Conjuntos, que já redirecionavam antes das áreas.
  ['/backoffice/cadastros/caminhoes', '/logistica/conjuntos/caminhoes'],
  ['/backoffice/cadastros/maquinarios', '/logistica/conjuntos/maquinas'],
  // Todos os outros cadastros são da Logística: os gerais moraram no Administrativo
  // de 24/10 a 26/10/2026 e voltaram a pedido do Samuel. As Categorias foram para o
  // Administrativo em 04/11/2026, também a pedido dele.
  ['/backoffice/cadastros', '/logistica/cadastros'],
  ['/backoffice/categorias', '/administrativo/categorias'],
  ['/backoffice/auditoria', '/administrativo/auditoria'],
  ['/backoffice', '/logistica'],
]

/** A lista antiga de contratos virou aba do hub de Cadastros da Logística. Só o
 *  endereço exato: detalhe e edição seguem em `/logistica/contracts/...`. */
const EXATOS: Readonly<Record<string, string>> = {
  '/backoffice/contracts': '/logistica/cadastros/contratos',
}

function casaPrefixo(caminho: string, prefixo: string): boolean {
  return caminho === prefixo || caminho.startsWith(`${prefixo}/`)
}

/** O caminho novo de um caminho antigo, ou `null` quando não é de `/backoffice`.
 *  Recebe só o caminho, sem busca nem âncora. Aceita o prefixo de um template, como
 *  `/backoffice/tickets/` antes de `${uuid}`, e preserva a barra final. */
export function caminhoNovo(caminho: string): string | null {
  if (!casaPrefixo(caminho, PREFIXO_LEGADO)) return null
  const exato = EXATOS[caminho]
  if (exato) return exato
  for (const [antigo, novo] of REGRAS) {
    if (casaPrefixo(caminho, antigo)) return novo + caminho.slice(antigo.length)
  }
  return null
}

/** Para o redirecionamento: troca o caminho e mantém busca e âncora. */
export function destinoDoLegado(pathname: string, search = '', hash = ''): string | null {
  const novo = caminhoNovo(pathname)
  return novo === null ? null : `${novo}${search}${hash}`
}
